function check(name, value, ...params) {
	if (!value && value !== 0) {
		throw new Error(`
      BUILTIN ERROR - ${name} has an invalid value: ${value};
      current parameters ${JSON.stringify(params)}
    `);
	}
}
function supplierPerformance(s, args) {
	const {
		supplierPerformance1,
		supplierPerformance2,
		supplierPerformance3
	} = args;
	let res;
	switch (Number(s)) {
	case 1:
		res = supplierPerformance1;
		break;
	case 2:
		res = supplierPerformance2;
		break;
	case 3:
		res = supplierPerformance3;
		break;
	default:
		console.log('FATAL: can not find this supplier performance choice: ' + s);
	}
	check('supplierPerformance', res, s, args);
	return res;
}
function supplierBottlePerformance(s, args) {
	const {
		supplierBottlePerformance1,
		supplierBottlePerformance2,
		supplierBottlePerformance3
	} = args;
	let res;
	switch (Number(s)) {
	case 1:
		res = supplierBottlePerformance1;
		break;
	case 2:
		res = supplierBottlePerformance2;
		break;
	case 3:
		res = supplierBottlePerformance3;
		break;
	default:
		console.log('FATAL: can not find this supplier bottles choice: ' + s);
	}
	check('supplierBottlePerformance', res, s, args);
	return res;
}
function qualityCheckPerformance(n, args) {
	let value;
	const {
		qualityCheckPerformance1,
		qualityCheckPerformance2,
		qualityCheckPerformance3,
		qualityCheckPerformance4
	} = args;
	switch (Number(n)) {
	case 1:
		value = qualityCheckPerformance1;
		break;
	case 2:
		value = qualityCheckPerformance2;
		break;
	case 3:
		value = qualityCheckPerformance3;
		break;
	case 4:
	case 5:
		value = qualityCheckPerformance4;
		break;
	default:
		console.log('FATAL: can not find this check perfomance number: ' + n);
	}
	return value;
}
function marketingBudgetPerformance(
	marketing,
	{
		marketingBudgetPerformance_range1_min,
		marketingBudgetPerformance_range1_max,
		marketingBudgetPerformance_range1_const1,
		marketingBudgetPerformance_range2_min,
		marketingBudgetPerformance_range2_max,
		marketingBudgetPerformance_range2_const1,
		marketingBudgetPerformance_range2_const2,
		marketingBudgetPerformance_range3_min,
		marketingBudgetPerformance_range3_max,
		marketingBudgetPerformance_range3_const1,
		marketingBudgetPerformance_range3_const2,
		marketingBudgetPerformance_range4_min,
		marketingBudgetPerformance_range4_max,
		marketingBudgetPerformance_range4_const1,
		marketingBudgetPerformance_range4_const2,
		marketingBudgetPerformance_range5_min,
		marketingBudgetPerformance_range5_max,
		marketingBudgetPerformance_range5_const1,
		marketingBudgetPerformance_range5_const2,
		marketingBudgetPerformance_range6_min,
		marketingBudgetPerformance_range6_const1
	}
) {
	if (
		marketingBudgetPerformance_range1_min <= marketing &&
		marketing < marketingBudgetPerformance_range1_max
	) {
		return marketingBudgetPerformance_range1_const1 * marketing;
	}
	if (
		marketingBudgetPerformance_range2_min <= marketing &&
		marketing < marketingBudgetPerformance_range2_max
	) {
		return (
			marketingBudgetPerformance_range2_const1 * marketing +
			marketingBudgetPerformance_range2_const2
		);
	}
	if (
		marketingBudgetPerformance_range3_min <= marketing &&
		marketing < marketingBudgetPerformance_range3_max
	) {
		return (
			marketingBudgetPerformance_range3_const1 * marketing +
			marketingBudgetPerformance_range3_const2
		);
	}
	if (
		marketingBudgetPerformance_range4_min <= marketing &&
		marketing < marketingBudgetPerformance_range4_max
	) {
		return (
			marketingBudgetPerformance_range4_const1 * marketing +
			marketingBudgetPerformance_range4_const2
		);
	}
	if (
		marketingBudgetPerformance_range5_min <= marketing &&
		marketing < marketingBudgetPerformance_range5_max
	) {
		return (
			marketingBudgetPerformance_range5_const1 * marketing +
			marketingBudgetPerformance_range5_const2
		);
	}
	if (marketing >= marketingBudgetPerformance_range6_min) {
		return marketingBudgetPerformance_range6_const1;
	}
	console.log(
		'FATAL: can not find this marketingBudgetPerformance: ' + marketing
	);
}

export default {
	getEquity: (capitalExpenditures, time, last, args) => {
		const {
			capitalExpenditures_range1_min,
			capitalExpenditures_range1_const1,
			capitalExpenditures_range2_min,
			capitalExpenditures_range2_max,
			capitalExpenditures_range2_const1,
			capitalExpenditures_range3_min,
			capitalExpenditures_range4_const1
		} = args;
		if (time === 1) {
			if (capitalExpenditures >= capitalExpenditures_range1_min) {
				return capitalExpenditures_range1_const1;
			} else if (
				capitalExpenditures >= capitalExpenditures_range2_min &&
				capitalExpenditures <= capitalExpenditures_range2_max
			) {
				return capitalExpenditures_range2_const1;
			} else if (capitalExpenditures < capitalExpenditures_range3_min) {
				return capitalExpenditures;
			} else {
				return capitalExpenditures_range4_const1;
			}
		} else {
			return last;
		}
	},

	// prezzo (€)
	pricePerformance: (price, args) => {
		const {
			pricePerformance_range1_min,
			pricePerformance_range1_max,
			pricePerformance_range1_const1,
			pricePerformance_range1_const2,
			pricePerformance_range2_min,
			pricePerformance_range2_max,
			pricePerformance_range2_const1,
			pricePerformance_range2_const2,
			pricePerformance_range2_const3,
			pricePerformance_range2_const4,
			pricePerformance_range3_min,
			pricePerformance_range3_max,
			pricePerformance_range3_const1,
			pricePerformance_range4_min,
			pricePerformance_range4_max,
			pricePerformance_range4_const1,
			pricePerformance_range4_const2,
			pricePerformance_range4_const3,
			pricePerformance_range5_min,
			pricePerformance_range5_max,
			pricePerformance_range5_const1,
			pricePerformance_range5_const2,
			pricePerformance_range6_min,
			pricePerformance_range6_const1
		} = args;
		if (
			pricePerformance_range1_min <= price &&
			price < pricePerformance_range1_max
		) {
			return (
				price * pricePerformance_range1_const1 + pricePerformance_range1_const2
			);
		}
		if (
			pricePerformance_range2_min <= price &&
			price < pricePerformance_range2_max
		) {
			const a =
				pricePerformance_range2_const1 *
				Math.pow(price, pricePerformance_range2_const2);
			const b = pricePerformance_range2_const3 * price;
			const c = pricePerformance_range2_const4;
			return a + b + c;
		}
		if (
			pricePerformance_range3_min <= price &&
			price <= pricePerformance_range3_max
		) {
			return pricePerformance_range3_const1;
		}
		if (
			pricePerformance_range4_min < price &&
			price < pricePerformance_range4_max
		) {
			return (
				pricePerformance_range4_const1 /
				(pricePerformance_range4_const2 * price +
					pricePerformance_range4_const3)
			);
		}
		if (
			pricePerformance_range5_min <= price &&
			price < pricePerformance_range5_max
		) {
			return (
				pricePerformance_range5_const1 * price + pricePerformance_range5_const2
			);
		}
		if (price >= pricePerformance_range6_min) {
			return pricePerformance_range6_const1;
		}
		return null;
	},

	marketingPerformance: (marketing, supplierBottleChoice, builtinArgs) => {
		const {
			marketingPerformance_const1,
			marketingPerformance_const2
		} = builtinArgs;
		return (
			supplierBottlePerformance(supplierBottleChoice, builtinArgs) *
				marketingPerformance_const1 +
			marketingBudgetPerformance(marketing, builtinArgs) *
				marketingPerformance_const2
		);
	},

	daysReceivablePerformance: (
		days,
		{
			daysReceivablePerformance_range1_max,
			daysReceivablePerformance_range1_const1,
			daysReceivablePerformance_range2_min,
			daysReceivablePerformance_range2_max,
			daysReceivablePerformance_range2_const1,
			daysReceivablePerformance_range2_const2,
			daysReceivablePerformance_range3_min,
			daysReceivablePerformance_range3_max,
			daysReceivablePerformance_range3_const1,
			daysReceivablePerformance_range3_const2,
			daysReceivablePerformance_range4_min,
			daysReceivablePerformance_range4_max,
			daysReceivablePerformance_range4_const1,
			daysReceivablePerformance_range4_const2,
			daysReceivablePerformance_range5_min,
			daysReceivablePerformance_range5_const1
		}
	) => {
		if (days < daysReceivablePerformance_range1_max) {
			return daysReceivablePerformance_range1_const1;
		}
		if (
			daysReceivablePerformance_range2_min <= days &&
			days < daysReceivablePerformance_range2_max
		) {
			return (
				daysReceivablePerformance_range2_const1 * days +
				daysReceivablePerformance_range2_const2
			);
		}
		if (
			daysReceivablePerformance_range3_min <= days &&
			days < daysReceivablePerformance_range3_max
		) {
			return (
				daysReceivablePerformance_range3_const1 * days +
				daysReceivablePerformance_range3_const2
			);
		}
		if (
			daysReceivablePerformance_range4_min <= days &&
			days < daysReceivablePerformance_range4_max
		) {
			return (
				daysReceivablePerformance_range4_const1 * days +
				daysReceivablePerformance_range4_const2
			);
		}
		if (days >= daysReceivablePerformance_range5_min) {
			return daysReceivablePerformance_range5_const1;
		}
		return null;
	},

	marketingImportance: (
		price,
		{
			marketingImportance_const1,
			marketingImportance_const2,
			marketingImportance_const3
		}
	) =>
		marketingImportance_const1 +
		price / marketingImportance_const2 +
		marketingImportance_const3,

	demandQuota: (
		performance,
		{ demandQuota_const1, demandQuota_const2, demandQuota_const3 }
	) =>
		Math.min(
			demandQuota_const1 * Math.log(performance + demandQuota_const2),
			demandQuota_const3
		),

	qualityPerformance: (
		supplierAppleChoice,
		personel,
		recyclingAndWasteManagement,
		qualityMaintenance,
		juiceTaster,
		chemicalExpert,
		builtinArgs
	) => {
		const {
			qualityPerformance_const1,
			qualityPerformance_const2,
			qualityPerformance_const3,
			qualityPerformance_const4,
			qualityPerformance_const5,
			qualityPerformance_const6
		} = builtinArgs;
		return (
			supplierPerformance(supplierAppleChoice, builtinArgs) *
				qualityPerformance_const1 +
			qualityCheckPerformance(personel, builtinArgs) *
				qualityPerformance_const2 +
			recyclingAndWasteManagement * qualityPerformance_const3 +
			qualityMaintenance * qualityPerformance_const4 +
			juiceTaster * qualityPerformance_const5 +
			chemicalExpert * qualityPerformance_const6
		);
	},

	qualityImportance: (price, { qualityImportance_const1 }) =>
		price / qualityImportance_const1,

	normalizeSupposedQualityPerformance: (
		supposedQualityPerformance,
		{ normalizeSupposedQualityPerformance_const1 }
	) => {
		return (
			supposedQualityPerformance / normalizeSupposedQualityPerformance_const1
		);
	},

	longInterestRateTerm(
		longTermDebt,
		longInterestRateA,
		longInterestRateB,
		longInterestRateC,
		longInterestThresholdA,
		longInterestThresholdB
	) {
		if (longTermDebt < longInterestThresholdA) {
			return longInterestRateA;
		}

		if (
			longInterestThresholdA <= longTermDebt &&
			longTermDebt < longInterestThresholdB
		) {
			return longInterestRateB;
		}

		if (longInterestThresholdB <= longTermDebt) {
			return longInterestRateC;
		}

		return 0;
	},

	shortTermDebtFormula: (
		inventoryDelta,
		receivablesDelta,
		payablesDelta,
		preTaxIncome,
		fixedAssetsDepreciation,
		//togliere
		shortTermDebts,
		taxRate,
		shortTermDebtsLast,
		lastYearCash,
		{ shortTermDebtFormula_const1, shortTermDebtFormula_const2 }
	) => {
		let res = 0;
		if (preTaxIncome < 0) {
			res = Math.max(
				0,
				(-inventoryDelta -
					receivablesDelta -
					payablesDelta -
					preTaxIncome -
					fixedAssetsDepreciation +
					shortTermDebtsLast -
					lastYearCash) /
					(shortTermDebtFormula_const1 - shortTermDebtFormula_const2)
			);
		} else {
			res = Math.max(
				0,
				(-inventoryDelta -
					receivablesDelta -
					payablesDelta -
					preTaxIncome * (1 - taxRate) -
					fixedAssetsDepreciation +
					shortTermDebtsLast -
					lastYearCash) /
					(shortTermDebtFormula_const1 -
						shortTermDebtFormula_const2 * (1 - taxRate))
			);
			const interest = res * shortTermDebtFormula_const2;
			if (preTaxIncome - interest < 0) {
				res = Math.max(
					0,
					(-inventoryDelta -
						receivablesDelta -
						payablesDelta -
						preTaxIncome -
						fixedAssetsDepreciation +
						shortTermDebtsLast -
						lastYearCash) /
						(shortTermDebtFormula_const1 - shortTermDebtFormula_const2)
				);
			}
		}
		return res;
	}
};
